import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  margin-top: 50%;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: bold;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const ModalBody = styled.div``;

export const DropdownWrapper = styled.div`
  margin-bottom: 20px;
`;

export const DropdownLabel = styled.div`
  margin-bottom: 7px;
  font-weight: 500;
`;

export const CurrentPlan = styled.div``;

export const ProductName = styled.div`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.palette.grey63};
  margin-top: 5px;
`;

export const CurrentPlanLabel = styled.div`
  margin-bottom: 5px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.palette.grey63};
  font-weight: 500;
`;

export const CurrentPlanText = styled.div`
  color: #388e3c;
  font-size: 1rem;
  font-weight: 500;
`;

export const Notification = styled.div`
  display: flex;
  /* align-items: center; */
  margin-bottom: 20px;
`;

export const NotificationBody = styled.div`
  color: ${({ theme }) => theme.palette.grey63};
  margin-left: 3px;
  font-size: 0.9rem;
`;

export const NotificationIcon = styled.div`
  margin-right: 5px;
  min-width: 20px;
  min-height: 20px;
`;

export const GreyText = styled.p`
  color: grey;
  font-size: 14px;
  margin: 30px 0;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px black solid;
`;

export const ProductDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  margin-bottom: 15px;
`;

export const SubscriptionOption = styled.div<{ $isActive: boolean }>`
  border-radius: 5px;
  padding: 5px;
  > div > div:nth-child(2) {
    font-weight: ${({ $isActive }) => ($isActive ? 500 : 'normal')};
    font-size: 1rem;
  }
`;
